<section class="categories-section">
    <div class="generic-container categories-container">
        <div class="section-header">
            <h2 class="section-title animate-fade-in">
                Explore Our
                <span class="hero-gradient-text">Collections</span>
            </h2>
            <p class="section-description">
                Discover handpicked toys that inspire creativity, learning, and endless fun for all ages
            </p>
        </div>

        <div class="categories-grid">
            <app-category-card
                *ngFor="let category of categories"
                [title]="category.title"
                [description]="category.description"
                [image]="category.image"
                [target]="category.target"
                [queryParams]="category.queryParams"
                [variant]="category.variant"
            ></app-category-card>
        </div>
    </div>
</section>
